export const LANG = {
  ru: "ru",
  en: "en",
};

export const LOCALIZE_NAME_OPTIONS = [
  "name",
  "DealerName",
  "country",
  "FO",
  "subject",
  "city",
  "address",
  "type",
  "format",
  "period",
  "unit",
  "status",
];

export const EN_NAME_OPTIONS = [
  "nameEn",
  "DealerNameEn",
  "countryEn",
  "FOEn",
  "subjectEn",
  "cityEn",
  "addressEn",
  "typeEn",
  "formatEn",
  "periodEn",
  "unitEn",
  "statusEn",
];
